import { Component, Input, OnInit} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ParentLayers } from '../../../menu/view-menu/parent-layer';
import { NgForm} from '@angular/forms';
import { CalculationsService } from 'src/app/services/calculations.service';
import { CoverageQuantitativeAssessmentDTO } from '../../../models/coverageQuantitativeAssessmentDTO';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { TabsService } from 'src/app/services/tabsService';
import { CoverageQuantitativeAssessmentResultModel } from 'src/app/models/calculations';
import { ProjectService } from 'src/app/services/project.service';


@Component({
  selector: 'app-coverage-quantitative-assessment',
  templateUrl: './coverage-quantitative-assessment.component.html',
  styleUrls: ['../../../app.component.scss'],
  standalone: false
})
export class CoverageQuantitativeAssessmentComponent implements OnInit {

  @Input() elevation_info: string[] = [];
  @Input() layerName: string;
  @Input() id: number;

  public selectedElevation;
  public selectedArea = "FIR";
  public selectedFIR = "ECAC";
  public selectAllECAC = false;
  calculationsService: ParentLayers;

  public areasFIRECACTable: string[];
  public areasFIRENPTable: string[];
  public areasCountryTable: string[] =  ["LA - Albania", "UD - Armenia", "LO - Austria", "UB - Azerbaijan",
  "EB - Belgium", "LQ - Bosnia and Herzegovina", "LB - Bulgaria", "LD - Croatia", "LC - Cyprus", "LK - Czech Republic",
  "EK - Denmark", "EE - Estonia", "EF - Finland", "LF - France", "UG - Georgia", "ED - Germany", "LG - Greece", "LH - Hungary",
  "BI - Iceland", "EI - Ireland", "LI - Italy", "EV - Latvia", "EY - Lithuania", "EL - Luxembourg", "LM - Malta", "LU - Moldova",
  "LN - Monaco", "LY - Montenegro", "EH - Netherlands", "LW - North Macedonia", "EN - Norway", "EP - Poland", "LP - Portugal",
  "LR - Romania", "LY - Serbia", "LZ - Slovakia", "LJ - Slovenia", "LE - Spain", "ES - Sweden", "LS - Switzerland", "LT - Türkiye",
  "UK - Ukraine", "EG - United Kingdom"];

  public areasFIRECACGeoJSON: string;
  public areasFIRENPGeoJSON: string;
  public areasCountryGeoJSON: string;

  public coverageQuantitativeAssessmentDTO : CoverageQuantitativeAssessmentDTO;


  constructor(private bsModalRef : BsModalRef,
    private calculationService : CalculationsService,
    private modalService : ModalControlService,
    private tabsService: TabsService,
    private projectService: ProjectService) {
    this.coverageQuantitativeAssessmentDTO = new CoverageQuantitativeAssessmentDTO();
    //TODO : change directly in the shapefile instead of using this fix;
    this.fixNamesBeforeGetIcaoCode();
  }

  //TODO : change directly in the shapefile instead of using this fix;
  fixNamesBeforeGetIcaoCode(){
    this.areasCountryTable.forEach(function(part, index) {
      if(part == 'LT - Türkiye'){
        this[index] = "LT - Turkey";
      }

    }, this.areasCountryTable); // use arr as this
  }


  async ngOnInit(): Promise<void> {
    this.areasFIRECACTable = await (await this.fillListsAndGeoJSONFiles("ECAC_FIRUIR_Lower")).sort((n1,n2) => {
      if (n1 > n2) {
          return 1;
      }

      if (n1 < n2) {
          return -1;
      }

      return 0;
  });;
    this.areasCountryGeoJSON
    this.areasFIRENPTable = await (await this.fillListsAndGeoJSONFiles("ENP_FIRUIR_Lower")).sort((n1,n2) => {
      if (n1 > n2) {
          return 1;
      }

      if (n1 < n2) {
          return -1;
      }

      return 0;
  });;
    this.fillListsAndGeoJSONFiles("world");
    this.selectedElevation = this.elevation_info[0];
  }

  removeSelectAll(): void {
    this.selectAllECAC = false;
  }


  private async fillListsAndGeoJSONFiles(selectedOption: string) : Promise<string[]> {
    // get url to request to geoServer
    const url = (
      'https://docker11723-dev-demeter.jelastic.labs.gmv.com/geoserver/DEMETER/ows?' +
      new URLSearchParams({'service': 'WFS', 'version':'1.0.0',
      'request': 'GetFeature','typeName': 'DEMETER:' + selectedOption,
      'maxFeatures':'300', 'outputFormat':'application/json'} ).toString()
    );

    // send request to geoServer and read features to add to list
    let response = await fetch(url)
    .then(function (response) {
      return response.text();
    })
    // save geoJSON to send to backend after
    switch (selectedOption){
      case 'ECAC_FIRUIR_Lower':
        this.areasFIRECACGeoJSON = response;
        break;
      case 'ENP_FIRUIR_Lower':
        this.areasFIRENPGeoJSON = response;
        break;
      case 'world':
        this.areasCountryGeoJSON = response;
        return; // countries table is hardcoded so no need to proceed
    }
    //search names in geoJSON to add to table
    const allFeatures = JSON.parse(await response);
    let ICAOcodes:string[] = [];
    for (let feature of allFeatures.features){
      if (feature.properties.IDENT_TXT != null && feature.properties.NAME_TXT != null) {
          let name = feature.properties.IDENT_TXT + " - "
              + feature.properties.NAME_TXT;
          ICAOcodes.push(name);
      }
    }
    // remove duplicates
    let listWithNoDuplicates = (function(arr){
      var m = {}, newarr = []
      for (var i=0; i<arr.length; i++) {
        var v = arr[i];
        if (!m[v]) {
          newarr.push(v);
          m[v]=true;
        }
      }
      return newarr;
    })(ICAOcodes);

    return listWithNoDuplicates;

  }
  private getICAOSelected (form): string[] {

    if (this.selectAllECAC){ // select all is selected
      if (this.selectedArea == "FIR"){ // FIR is selected
        if (this.selectedFIR == "ECAC"){ // ECAC is selected
          this.coverageQuantitativeAssessmentDTO.geoJSON = this.areasFIRECACGeoJSON;
          return this.areasFIRECACTable;
        } else { // ENP is selected
          this.coverageQuantitativeAssessmentDTO.geoJSON = this.areasFIRENPGeoJSON;
          return this.areasFIRENPTable;
        }
      } else { // country is selected
        this.coverageQuantitativeAssessmentDTO.geoJSON = this.areasCountryGeoJSON;
        return this.areasCountryTable;
      }
    } else { // select all is not selected
      if (this.selectedArea == "FIR"){ // FIR is selected
        if (this.selectedFIR == "ECAC"){ // ECAC is selected
          this.coverageQuantitativeAssessmentDTO.geoJSON = this.areasFIRECACGeoJSON;
          return this.getSelectedFromTable(form, this.areasFIRECACTable);
        } else { // ENP is selected
          this.coverageQuantitativeAssessmentDTO.geoJSON = this.areasFIRENPGeoJSON;
          return this.getSelectedFromTable(form, this.areasFIRENPTable);
        }
      } else { // country is selected
        this.coverageQuantitativeAssessmentDTO.geoJSON = this.areasCountryGeoJSON;
        return this.getSelectedFromTable(form, this.areasCountryTable);

      }
    }
  }
  private getSelectedFromTable(form, table:string[]): string[] {
    var output: string[] = [];
    for (const icao of table){
      if (form.controls[icao].value){
        output.push(icao);
      }
    }
    return output;
  }

  performOk(form): void {
    this.coverageQuantitativeAssessmentDTO.icaoSelected = this.getICAOSelected(form);
    if (this.coverageQuantitativeAssessmentDTO.icaoSelected.length > 0){
      this.coverageQuantitativeAssessmentDTO.elevation = this.selectedElevation;
      this.coverageQuantitativeAssessmentDTO.layerName = this.layerName;
      this.coverageQuantitativeAssessmentDTO.calcID = this.id.toString();
      this.coverageQuantitativeAssessmentDTO.selectedArea = this.selectedArea;
      this.coverageQuantitativeAssessmentDTO.selectedFIR = this.selectedFIR;
      this.coverageQuantitativeAssessmentDTO.projectId = this.projectService.activeProject.id;
      this.bsModalRef.hide();
      this.calculationService.calculateCoverageQuantitativeAssessment(this.coverageQuantitativeAssessmentDTO)
      .subscribe(
        {
          error: (error) => this.calculationService.showError(error)
        }
      );
    } else {
      this.modalService.showMesssageModal(
        'Warning',
        'Please select at least 1 area'
      );
    }
  }
  cancelImport(): void {
    this.bsModalRef.hide();
  }


}
